import { render } from "./functionDetail.vue?vue&type=template&id=d5d00b82&scoped=true"
import script from "./functionDetail.vue?vue&type=script&lang=js"
export * from "./functionDetail.vue?vue&type=script&lang=js"

import "./functionDetail.vue?vue&type=style&index=0&id=d5d00b82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d00b82"]])

export default __exports__